import React from "react";
import "./PantallaCarga.css";

function PantallaCarga() {
  return (
    <div className="loader-screen">

      <div className="loader-container">

        <div className="loader-logo">
          <div className="loader-orbit">
            <div className="loader-dot"></div>
          </div>
        </div>

        <h2 className="loader-title">
          Cargando <span>Tresatec</span>
        </h2>

        <div className="loader-bar">
          <div className="loader-progress"></div>
        </div>

      </div>

    </div>
  );
}

export default PantallaCarga;